/**
 * @desc 查询新闻分页列表
 */
import {
  PageNewsEntity,
  MallNewsPageQuery
} from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryNewsPageParameter = MallNewsPageQuery

const method = 'GET'
const url = '/content/mall/news/page'

export const queryNewsPageApi = (
  params?: QueryNewsPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageNewsEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryNewsPageApi.method = method
queryNewsPageApi.url = url
